export default __webpack_public_path__ + "static/media/ac.935d86d2.svg";